import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      {/* Navbar content removed */}
    </nav>
  );
};

export default Navbar;
